module.exports = __webpack_public_path__ + "static/media/type-walking-logo.78387d8b.gif";